import React, { useEffect, useState } from 'react'
import Loading from "../images/sprite/loading40.gif"
import axios from "axios";

export default function ActivityLog(props) {

   const [LogHistory, setLogHistory] = useState([]);


   useEffect(() => {
      if (!props.userid) return;
      axios
         .post("https://liveapi247.live/api1/activityLogs", {
            id: props.userid,
         })
         .then((result) => {
            if (result.status === 210) {
               setLogHistory(result.data);
            }
         })
         .catch((e) => {
            //setIsError(true);
         });
   }, []);

   return (
      <React.Fragment>


         {/* <div _ngcontent-lst-c67="" class="centar-content report" >

            <div _ngcontent-lst-c67="" id="message" class="message-content success">
               <a _ngcontent-lst-c67="" class="close-button">Close</a>

            </div>

            <h2 _ngcontent-lst-c67="" >Activity Log
            </h2>

            <table _ngcontent-lst-c67="" class="table01">
               <tbody _ngcontent-lst-c67="" >
                  <tr _ngcontent-lst-c67="" >
                     <th style={{ width: '18%' }} class="align-L">Login Date &amp; Time
                     </th>
                     <th _ngcontent-lst-c67="" style={{ width: '30%' }} class="align-L">Login Status
                     </th>
                     <th _ngcontent-lst-c67="" style={{ width: '15%' }}>IP Address
                     </th>
                     <th _ngcontent-lst-c67="" style={{ width: " 28%" }} >ISP
                     </th>
                     <th _ngcontent-lst-c67="" >City/State/Country
                     </th>
                  </tr>
               </tbody>
               <tbody _ngcontent-lst-c67="" id="content">


                  {LogHistory.map(function (item, index) {
                     return (

                        <tr _ngcontent-fgb-c56="" id="tempTr">
                           <td _ngcontent-fgb-c56="" id="loginDate" class="align-L">{item.loginDateTime}</td>
                           <td _ngcontent-fgb-c56="" id="loginMessage" class="align-L green">{item.remark}</td>
                           <td _ngcontent-fgb-c56="" id="ipAddress">{item.ipAdress}</td>
                           <td _ngcontent-fgb-c56="" id="isp">{item.ISPN}</td>
                           <td _ngcontent-fgb-c56="" id="location">{item.Country}</td>
                        </tr>

                     )
                  })}


               </tbody>
            </table>



         </div> */}
         <div _nghost-nev-c7>
            <div _ngcontent-nev-c7 className="animated fadeIn divider-top">
               <div _ngcontent-nev-c7 className="row">
                  <div _ngcontent-nev-c7 className="col-sm-12 col-md-12  p-mobile-1">
                     <div _ngcontent-nev-c7 className="card card-accent-primary">
                        <div _ngcontent-nev-c7 className="card-header account-detail-head"> Activity Log </div>
                        <div _ngcontent-nev-c7 className="card-body account-stat-body">
                           <div _ngcontent-nev-c7 className="row">
                              <div _ngcontent-nev-c7 className="col-md-12 p-mobile-0">
                                 <div _ngcontent-nev-c7 className="table-responsive">
                                    <table _ngcontent-nev-c7 className="table table-bordered">
                                       <thead _ngcontent-nev-c7>
                                          <tr>
                                             <th _ngcontent-nev-c7>Login Date &amp; Time</th>
                                             <th _ngcontent-nev-c7>Login Status</th>
                                             <th _ngcontent-nev-c7>IP Address</th>
                                             <th _ngcontent-nev-c7>ISP</th>
                                             <th _ngcontent-nev-c7>City/State/Country</th>
                                          </tr>
                                       </thead>
                                       <tbody _ngcontent-nev-c7>{/**/}
                                          {LogHistory.map(function (item, index) {
                                             return (
                                                <tr _ngcontent-nev-c7>
                                                   <td _ngcontent-nev-c7>{item.loginDateTime}</td>
                                                   <td _ngcontent-nev-c7>
                                                      <span _ngcontent-nev-c7 className="login-success">{item.remark}</span></td>
                                                   <td _ngcontent-nev-c7>{item.ipAdress}</td>
                                                   <td _ngcontent-nev-c7>{item.ISPN}</td>
                                                   <td _ngcontent-nev-c7>{item.Country}</td>
                                                </tr>
                                             )
                                          })}
                                       </tbody>
                                    </table>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>


      </React.Fragment>
   )
}
